import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { getDataView } from 'app/modules/rules/service/rulesService';
import { getDataViewRules } from 'app/modules/rules/service/store/selectors';
import { View } from 'app/modules/rules/domain/View';
import ConfComp from 'app/shared/components/common/conf-component';
import './style.scss';
import { IRootState } from 'app/shared/reducers';
import { cleanUpdatedSellingPoint } from 'app/modules/sellingPoint/service/sellingPointService';
import { getAccount } from 'app/modules/user/service/store/selectors';
import { checkBicAndIbanSellingPoint } from 'app/modules/financial/service';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import { getAccountSelector, getModalInformationButton } from 'app/modules/cms/service/store/selectors';
import ModalWithAction from 'app/shared/components/common/modal/modal-with-Action';

const Account = () => {
  const rulesContext: RulesContext = {
    key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
    entryDataRules: { view: View.ACCOUNT_PAGE },
  };
  const dispatchor = useDispatch();
  const viewDataitems = useSelector(getDataViewRules(View.ACCOUNT_PAGE));
  const sellingPointInfo: any = useSelector<IRootState>(state => state.sellingPoint.connectedSellingPoint);
  const global: any = useSelector<IRootState>(state => state.global);
  const updateLoading: any = useSelector<IRootState>(state => state.sellingPoint.updateLoading);
  const updatedSellingPoint: any = useSelector<IRootState>(state => state.sellingPoint.updated);
  const modalInformation: any = useSelector(getModalInformationButton);
  const account = useSelector(getAccount);
  const errorIban: any = useSelector<IRootState>(state => state.finance.error);
  const accountCms: any = useSelector(getAccountSelector);
  const [updated, setUpdated] = useState(false);
  const [updateInfoBank, setUpdateInfoBank] = useState(false);
  const handleCheckBicAndIban = (value: any) => {
   return dispatchor(checkBicAndIbanSellingPoint(value));
  };

  useEffect(() => {
    dispatchor(getDataView(rulesContext));
    dispatchor(getDocCMS('desktop_account'));
  }, []);

  const infoBank = {
    companyName: (sellingPointInfo?.details || [])[0]?.bankInfos?.companyName || '',
    bic: (sellingPointInfo?.details || [])[0]?.bankInfos?.bic || '',
    iban: (sellingPointInfo?.details || [])[0]?.bankInfos?.iban || '',
  };

  useEffect(() => {
    if (updatedSellingPoint) {
      setUpdated(true)
      setUpdateInfoBank(false)
    }
    dispatchor(cleanUpdatedSellingPoint())
  }, [updatedSellingPoint]);





  return (
    <div className="account-conatainer">
      <ConfComp
        code="BANK_INFO_COMPONENT"
        listCode={viewDataitems?.componentDataList}
        props={{
          infoBankData: infoBank,
          error: errorIban,
          sellingPointInfo,
          updateLoading,
          account,
          pCode: global?.configuration?.productCode,
          handleCheckBicAndIban,
          accountBankInfoCms: accountCms.account_bank_info,
          updateInfoBank, setUpdateInfoBank,
          modalInformation
          
        }}
      />
     
       <ModalWithAction
              showModal={updated}
              setShowModel={setUpdated}
              textBody={accountCms?.account_bank_info?.modal_success_message}
              icon={modalInformation?.Success_Icon?.url}
              btnCloseLabel={modalInformation?.CONFIRMED_button}
            />
    </div>
  );
};

export default Account;
